(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root && root.document) {
    root.BloomingfulDeliveryAvailability = api;
    api.init(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var selector = '[data-bf-earliest-delivery-display]';
  var freshHolidayCache = {};
  var bouquetHolidayCache = {};
  var deliveryWeekdayLabels = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
  var deliveryMonthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  function addDays(date, amount) {
    var next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + amount);
    return next;
  }

  function toYmd(date) {
    return date.toISOString().slice(0, 10);
  }

  function parseYmd(value) {
    var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;

    var date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
    return toYmd(date) === match[0] ? date : null;
  }

  function sameDate(first, second) {
    return Boolean(first && second && toYmd(first) === toYmd(second));
  }

  function pacificNow(now) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(now || new Date());
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    return {
      date: new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day))),
      hour: Number(values.hour),
      minute: Number(values.minute),
      second: Number(values.second)
    };
  }

  function observedFixedHoliday(year, month, day) {
    var holiday = new Date(Date.UTC(year, month, day));
    if (holiday.getUTCDay() === 6) return addDays(holiday, -1);
    if (holiday.getUTCDay() === 0) return addDays(holiday, 1);
    return holiday;
  }

  function nthWeekdayOfMonth(year, month, weekday, occurrence) {
    var date = new Date(Date.UTC(year, month, 1));
    date.setUTCDate(1 + ((7 + weekday - date.getUTCDay()) % 7) + ((occurrence - 1) * 7));
    return date;
  }

  function lastWeekdayOfMonth(year, month, weekday) {
    var date = new Date(Date.UTC(year, month + 1, 0));
    date.setUTCDate(date.getUTCDate() - ((7 + date.getUTCDay() - weekday) % 7));
    return date;
  }

  function freshHolidaysForYear(year) {
    if (freshHolidayCache[year]) return freshHolidayCache[year];
    var holidays = {};

    function add(date) {
      holidays[toYmd(date)] = true;
    }

    for (var legalYear = year - 1; legalYear <= year + 1; legalYear += 1) {
      add(observedFixedHoliday(legalYear, 0, 1));
      add(nthWeekdayOfMonth(legalYear, 0, 1, 3));
      add(nthWeekdayOfMonth(legalYear, 1, 1, 3));
      add(lastWeekdayOfMonth(legalYear, 4, 1));
      add(observedFixedHoliday(legalYear, 5, 19));
      add(observedFixedHoliday(legalYear, 6, 4));
      add(nthWeekdayOfMonth(legalYear, 8, 1, 1));
      add(nthWeekdayOfMonth(legalYear, 9, 1, 2));
      add(observedFixedHoliday(legalYear, 10, 11));
      add(nthWeekdayOfMonth(legalYear, 10, 4, 4));
      add(observedFixedHoliday(legalYear, 11, 25));
    }

    freshHolidayCache[year] = holidays;
    return holidays;
  }

  function isFreshHoliday(date) {
    return Boolean(freshHolidaysForYear(date.getUTCFullYear())[toYmd(date)]);
  }

  function isFreshBusinessDay(date) {
    var weekday = date.getUTCDay();
    return weekday >= 1 && weekday <= 5 && !isFreshHoliday(date);
  }

  function isFreshShipmentDay(date) {
    return isFreshBusinessDay(date) && !isFreshHoliday(addDays(date, 1));
  }

  function isFreshDeliveryDay(mode, date) {
    if (!date || !Number.isFinite(date.getTime())) return false;
    var firstWeekday = mode === 'fresh-bunch-week-ahead' || mode === 'bunch-week-ahead' ? 3 : 2;
    return date.getUTCDay() >= firstWeekday && date.getUTCDay() <= 6 && isFreshShipmentDay(addDays(date, -1));
  }
  function previousFreshBusinessDay(date) {
    var previous = addDays(date, -1);
    while (!isFreshBusinessDay(previous)) previous = addDays(previous, -1);
    return previous;
  }

  function freshEarliest(mode, now) {
    var pacific = pacificNow(now);
    var currentSeconds = (pacific.hour * 3600) + (pacific.minute * 60) + pacific.second;

    if (mode === 'fresh-bunch-week-ahead' || mode === 'bunch-week-ahead') {
      var nextSunday = addDays(pacific.date, (7 - pacific.date.getUTCDay()) % 7);
      var weeklyDelivery = addDays(nextSunday, 3);
      while (!isFreshDeliveryDay(mode, weeklyDelivery)) weeklyDelivery = addDays(weeklyDelivery, 1);
      return weeklyDelivery;
    }
    if (mode === 'fresh-bunch' || mode === 'bunch') {
      var bunchShipment = new Date(pacific.date.getTime());
      if (!isFreshShipmentDay(bunchShipment) || currentSeconds >= (9 * 3600)) {
        bunchShipment = addDays(bunchShipment, 1);
        while (!isFreshShipmentDay(bunchShipment)) bunchShipment = addDays(bunchShipment, 1);
      }
      return addDays(bunchShipment, 1);
    }

    var cutoffSeconds = (mode === 'fresh-garland' || mode === 'garland' ? 14 : 9) * 3600;
    var shipmentDate = addDays(pacific.date, 1);

    while (true) {
      if (isFreshShipmentDay(shipmentDate)) {
        var cutoffDay = previousFreshBusinessDay(shipmentDate);
        if (pacific.date < cutoffDay || (sameDate(pacific.date, cutoffDay) && currentSeconds < cutoffSeconds)) {
          return addDays(shipmentDate, 1);
        }
      }
      shipmentDate = addDays(shipmentDate, 1);
    }
  }

  function bouquetHolidaysForYear(year) {
    if (bouquetHolidayCache[year]) return bouquetHolidayCache[year];
    var holidays = {};

    function add(date) {
      holidays[toYmd(date)] = true;
    }

    for (var legalYear = year - 1; legalYear <= year + 1; legalYear += 1) {
      add(new Date(Date.UTC(legalYear, 0, 1)));
      add(observedFixedHoliday(legalYear, 0, 1));
      add(nthWeekdayOfMonth(legalYear, 0, 1, 3));
      add(nthWeekdayOfMonth(legalYear, 1, 1, 3));
      add(lastWeekdayOfMonth(legalYear, 4, 1));
      add(new Date(Date.UTC(legalYear, 5, 19)));
      add(observedFixedHoliday(legalYear, 5, 19));
      add(new Date(Date.UTC(legalYear, 6, 4)));
      add(observedFixedHoliday(legalYear, 6, 4));
      add(nthWeekdayOfMonth(legalYear, 8, 1, 1));
      add(nthWeekdayOfMonth(legalYear, 10, 4, 4));
      add(new Date(Date.UTC(legalYear, 11, 25)));
      add(observedFixedHoliday(legalYear, 11, 25));
    }

    bouquetHolidayCache[year] = holidays;
    return holidays;
  }

  function isBouquetHoliday(date) {
    return Boolean(bouquetHolidaysForYear(date.getUTCFullYear())[toYmd(date)]);
  }

  function isBouquetBusinessDay(date) {
    var weekday = date.getUTCDay();
    return weekday >= 1 && weekday <= 5 && !isBouquetHoliday(date);
  }

  function nextBouquetBusinessDayOnOrAfter(date) {
    var next = new Date(date.getTime());
    while (!isBouquetBusinessDay(next)) next = addDays(next, 1);
    return next;
  }

  function addBouquetBusinessDaysAfter(date, amount) {
    var next = new Date(date.getTime());
    var remaining = Math.max(0, Number(amount) || 0);

    while (remaining > 0) {
      next = addDays(next, 1);
      if (isBouquetBusinessDay(next)) remaining -= 1;
    }

    return next;
  }

  function normalizeBouquetDeliveryDate(date) {
    var next = new Date(date.getTime());

    if (next.getUTCDay() === 0) {
      return addDays(next, 1);
    }

    if (isBouquetHoliday(next)) {
      return nextBouquetBusinessDayOnOrAfter(addDays(next, 1));
    }

    return next;
  }

  function bouquetEarliest(options, now) {
    var settings = options || {};
    var pacific = pacificNow(now);
    var processingDays = Math.max(0, parseInt(settings.processingDays || 0, 10) || 0);
    var processingStart;

    if (pacific.hour < 9 && isBouquetBusinessDay(pacific.date)) {
      processingStart = pacific.date;
    } else {
      processingStart = nextBouquetBusinessDayOnOrAfter(addDays(pacific.date, 1));
    }

    processingStart = addBouquetBusinessDaysAfter(processingStart, processingDays);

    var earliest = addDays(processingStart, 1);
    var configuredFirstDate = parseYmd(settings.firstDeliveryDate);
    if (configuredFirstDate && earliest < configuredFirstDate) earliest = configuredFirstDate;

    return normalizeBouquetDeliveryDate(earliest);
  }

  function formatDate(date, compact, currentYear) {
    var label = deliveryWeekdayLabels[date.getUTCDay()] + ', ' + deliveryMonthLabels[date.getUTCMonth()] + ' ' + date.getUTCDate();
    if (date.getUTCFullYear() !== currentYear) label += ', ' + date.getUTCFullYear();
    return label;
  }

  function renderTarget(target, now) {
    var mode = target.getAttribute('data-bf-delivery-mode') || '';
    if (!mode) return null;

    var date = mode === 'bouquet'
      ? bouquetEarliest({
          processingDays: target.getAttribute('data-bf-processing-days'),
          firstDeliveryDate: target.getAttribute('data-bf-first-delivery-date')
        }, now)
      : freshEarliest(mode, now);
    var pacific = pacificNow(now);
    var compact = target.getAttribute('data-bf-delivery-format') === 'compact';
    var fullDate = formatDate(date, false, pacific.date.getUTCFullYear());
    var visibleDate = formatDate(date, compact, pacific.date.getUTCFullYear());

    var textTarget = target.querySelector ? target.querySelector('[data-bf-earliest-delivery-text]') : null;
    var deliveryLabel = mode === 'bouquet' ? 'Earliest requested delivery' : 'Earliest delivery';
    (textTarget || target).textContent = deliveryLabel + ': ' + visibleDate;
    target.setAttribute('title', deliveryLabel + ': ' + fullDate);
    target.setAttribute('data-bf-earliest-delivery-date', toYmd(date));
    target.removeAttribute('hidden');
    return date;
  }

  function findTargets(scope) {
    var targets = [];
    if (!scope) return targets;
    if (scope.nodeType === 1 && scope.matches(selector)) targets.push(scope);
    if (scope.querySelectorAll) {
      Array.prototype.push.apply(targets, scope.querySelectorAll(selector));
    }
    return targets;
  }

  function render(scope, now) {
    return findTargets(scope).map(function (target) {
      return renderTarget(target, now);
    });
  }

  function init(doc) {
    function start() {
      if (doc.documentElement.getAttribute('data-bf-delivery-availability-ready') === 'true') return;
      doc.documentElement.setAttribute('data-bf-delivery-availability-ready', 'true');
      render(doc);

      if (typeof MutationObserver !== 'undefined' && doc.body) {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) render(node);
            });
          });
        }).observe(doc.body, { childList: true, subtree: true });
      }

      doc.addEventListener('shopify:section:load', function (event) {
        render(event.target || doc);
      });

      setInterval(function () {
        render(doc);
      }, 60000);
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  return {
    bouquetEarliest: bouquetEarliest,
    formatDate: formatDate,
    freshEarliest: freshEarliest,
    isFreshDeliveryDay: isFreshDeliveryDay,
    init: init,
    parseYmd: parseYmd,
    render: render,
    renderTarget: renderTarget,
    toYmd: toYmd
  };
});
